<template>
  <div class="filterlist">
    <FilterItem
      v-for="filter in filtersWithValue"
      :key="filter.key"
      :filter="filter"
      @removeFilter="$emit('removeFilter', filter.key)" />
    <i class="ms-Icon ms-Icon--Edit pencil"
      @click="$emit('editFilters')"
       title="Edit" 
       aria-hidden="true">
      <span>{{$t("edit")}}</span>
    </i>
  </div>
</template>

<script>
import FilterItem from '@/components/filterviewer/filterItem.vue';


export default {
  name: 'FiltersViewer',
  props:["fields"],
  emits:["editFilters","removeFilter"],
  components:{
    FilterItem
  },
  computed:{
    filtersWithValue() {
      if(!this.fields){
        return [];
      }
      const formkeys = Object.keys(this.fields); 
      let filters = [];
      formkeys.forEach(key => {
        if(this.fields[key].value != null){
          filters.push({
            ...this.fields[key],
            label: this.fields[key].value.label,
            key: key,
            required: this.fields[key]?.required ?? false
          })
        }
      });
      return filters;
    }
  }
}
</script>

<style scoped>
.filterlist{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

i.pencil{
  color: #1976d2;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 16px;
}

i.pencil span{
  font-family: "Montserrat";
  margin-left: 5px;
  font-family: Montserrat Semibold;
  font-size: 14px;
  color: #1976d2;
}

i.pencil:hover{
  cursor: pointer;
}

i.pencil span:hover {
  color: #2650e7;
}

i.pencil:hover{
  cursor: pointer;
  color: #2650e7;
  background-color: #f5f3f3;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  border-radius: 4px;
  padding-right: 10px;
}

i.pencil {
  cursor: pointer;
  color: #1976d2;
  background-color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  border-radius: 4px;
  padding-right: 10px;
}

i.pencil:hover, i.pencil:hover span {
  color: #2650e7;
}
</style>